const SPRITE_URL = "/icons/svg-sprite/svg-sprite.svg";

let spriteDoc: Document | null = null;
let loadPromise: Promise<Document> | null = null;

export function loadSprite(): Promise<Document> {
  if (spriteDoc) return Promise.resolve(spriteDoc);
  if (loadPromise) return loadPromise;

  loadPromise = fetch(SPRITE_URL)
    .then((res) => res.text())
    .then((text) => {
      spriteDoc = new DOMParser().parseFromString(text, "image/svg+xml");
      return spriteDoc;
    });

  return loadPromise;
}

export function getSpriteSymbol(name: string): Element | null {
  return spriteDoc?.getElementById(name) ?? null;
}
